import posthog from 'posthog-js'

posthog.init(import.meta.env.VITE_POSTHOG_ID as string, {
  api_host: 'https://us.i.posthog.com',
})
